<span class="relative flex flex-col w-full h-full">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'label_copy_data_from_another_mortgage_eligibility_info' | translate }}</div>
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button (click)="close()" mat-icon-button [matDialogClose]="undefined">
                <mat-icon class="white-color" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>

    @if (false) {
    <div class="p-6" mat-dialog-content>
        <div class="grid sm:grid-cols-4 gap-6 w-full mt-[220px]">
            <div class="col-span-4">
                <app-loader-inline class="float-left mt-[50px]"></app-loader-inline>
            </div>
        </div>
    </div>
    } @if (true) {
    <form [formGroup]="form" class="mx-8 my-4">
        <div>{{ 'info_copy_data_from_another_mortgage_eligibility_info' | translate }}</div>
        <mat-divider class="my-4"></mat-divider>
        @if (form) {
        <div class="grid grid-cols-1 w-full gap-4 margin-top margin-bottom-10">
            <mat-form-field class="fuse-mat-no-subscript col-span-2 sm:col-span-1 lg:flex-1">
                <mat-label> {{ 'label_mortgage_eligibility_info_id' | translate }} </mat-label>
                <input formControlName="searchString" matInput />
                @if (!loading && state == 'invalid') {
                <mat-icon class="icon-size-5 validation-error-color" fontIcon="close" matSuffix></mat-icon>
                } @if (!loading && state == 'valid') {
                <mat-icon class="icon-size-5 text-green-600" fontIcon="check" matSuffix></mat-icon>
                } @if (loading) {
                <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'"> </mat-progress-spinner>
                }
            </mat-form-field>
        </div>
        } @if (sourceInfoId == data.id && state == 'valid') {
        <div class="validation-error-color">{{ 'error_target_and_source_mortgage_eligibility_infos_cannot_be_the_same' | translate }}</div>
        }
        <div class="my-4">
            <strong>{{ 'info_note_mortgage_eligibility_info_copy_all_data_updated_and_not_refetched' | translate }}</strong>
            <div>
                <a
                    href="https://lsr.atlassian.net/wiki/spaces/LEIB/pages/639107075/5.3.2.2+-+Afrita+uppl+singar+r+einu+ve+h+fisskjali+anna"
                    target="_blank"
                    >Nánari upplýsingar í Confluence.</a
                >
            </div>
        </div>
        <div class="flex justify-end">
            <button
                (click)="submit()"
                mat-flat-button
                [color]="'primary'"
                [disabled]="!form.valid || !sourceInfoId || sourceInfoId == data.id || loading"
            >
                @if (formEnabled) {
                <span>{{ 'label_confirm' | translate }}</span>
                } @if (!formEnabled) {
                <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                }
            </button>
        </div>
    </form>
    }
</span>
